<template>
	<div class="goods">
		<v-head :title="title"></v-head>
		<div class="content">
		<van-field label="抬头类型">
          <template v-if="this.userInfo.memberCategory == 1 || this.userInfo.memberCategory == 4" #input>
            <van-radio-group v-model="ruleFrom.titleType" direction="horizontal" @change="headUpType">
              <template v-for="item in TITLETYPE2">
                <van-radio :key="item.value" :name="item.value">{{
                  item.name
                  }}</van-radio>
              </template>
            </van-radio-group>
          </template>
        </van-field>
        <div class="tishi">
			请您认真核实发票信息，提交后将无法修改，请确保信息填写正确，以免影响发票的后续使用。
		</div>
		<van-field required label="发票抬头" v-model="ruleFrom.companyName" class="input-item" placeholder="请输入发票抬头"></van-field>
		<van-field v-if="ruleFrom.titleType == 2" required label="纳税人识别号" v-model="ruleFrom.tin" class="input-item" placeholder="请输入纳税人识别号"></van-field>
		<van-field v-if="ruleFrom.titleType == 2" label="注册地址" v-model="ruleFrom.address" class="input-item" placeholder="请输入注册地址"></van-field>
		<van-field v-if="ruleFrom.titleType == 2" label="注册电话" v-model="ruleFrom.telephone" class="input-item" placeholder="请输入注册电话"></van-field>
		<van-field v-if="ruleFrom.titleType == 2" label="开户银行" v-model="ruleFrom.bank" class="input-item" placeholder="请输入开户银行"></van-field>
		<van-field v-if="ruleFrom.titleType == 2" label="银行账号" v-model="ruleFrom.account" class="input-item" placeholder="请输入银行账号"></van-field>
		<van-field required label="姓名" v-model="ruleFrom.contact" class="input-item" placeholder="请输入姓名"></van-field>
		<van-field required label="手机号" v-model="ruleFrom.mobile" class="input-item" placeholder="请输入手机号"></van-field>
		<van-field required label="邮箱" v-model="ruleFrom.email" class="input-item" placeholder="请输入邮箱"></van-field>	
		<!-- <van-field label="通讯地址" v-model="ruleFrom.detailedAddress" class="input-item" placeholder="请输入通讯地址"></van-field> -->
		<van-field label="发票金额" disabled v-model="ruleFrom.amount" class="input-item" placeholder="发票金额"></van-field>
		<van-action-sheet v-model="show" :actions="options" @select="choiceOfYears" title="请选择缴费年限">
		</van-action-sheet>
		<van-button class="successedBtn" type="primary" size="large" @click="submit">提交</van-button>
	</div>
</div>
</template>

<script type="text/javascript">
import vHead from "../../components/Subhead.vue";	
import {getSessionStore} from "@/utils/sessionStorage.js"
import { mapState } from "vuex";
import { Uploader,Toast, ActionSheet, Dialog, Field, Button, RadioGroup,
    Radio,} from "vant";
import {
	underLineSubmit,
	underLineSubmitMeeting,
	getDuesList,
	createOrder,
	memberAudit,
	getGroupDues
} from "@/api/dictionary";
export default {
  data() {
    return {
	  show: false,
      fileList: [],
	  commentImg:[],
	  title:"创建订单",
	  options: [{
			value: 1,
			name: '一年'
		}, {
			value: 2,
		name: '两年'
		}, {
			value: 3,
		name: '三年'
		}, {
			value: 4,
		name: '四年'
	  }],
	  params:{
        amount:null,
        price:null
      },
	  ruleFrom:{
		companyName:null,
		tin:null,
		address:null,
		telephone:null,
		bank:null,
		account:null,
		contact:null,
		mobile:null,
		email:null,
		detailedAddress:null,
		amount:null,
		titleType:1,
		invoiceType:1,
		contentType:1
	  },
	  TITLETYPE2:[{
		name:"个人",
		value:1,
	  },{
		name:"公司",
		value:2
	  }],
    }
  },
    components: {
    vHead,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [ActionSheet.name]: ActionSheet,
	[Dialog.Component.name]:Dialog.Component,
	[Field.name]: Field,
	[Button.name]: Button,
	[Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
  },
    methods: {
	  choiceOfYears(data){
			console.log(data)
			this.params.amount = this.params.price * data.value;
			if(this.userInfo.memberCategory == 2 && data.value == 4){
				this.params.amount = "7200";
			}
			Dialog.confirm({
				title: '标题',
				message: '缴费年数' + data.value + "年"+"缴费金额" + this.params.amount + "元"
			}).then(() => {
				//this.create(this.params.amount,data.value);
			//Toast.success('订单生成');
				this.show = false;
				this.ruleFrom.years = data.value;
				this.ruleFrom.amount = this.params.amount;
			}).catch(() => {
				//Toast.fail('缴费取消');
			});
		},

    submit() {
        const token = getSessionStore("access_token");
		this.ruleFrom.access_token = token;
		console.log(this.ruleFrom)
		if(!this.ruleFrom.companyName){
			Toast.fail("发票抬头不能为空");
			return;
		}
		if(this.ruleFrom.titleType == 2 && (!this.ruleFrom.tin || this.ruleFrom.tin.trim() === "")){
			Toast.fail("纳税人识别号不能为空");
			return;
		}
		if(!this.ruleFrom.contact){
			Toast.fail("姓名不能为空");
			return;
		}
		if(!this.ruleFrom.mobile){
			Toast.fail("手机号不能为空");
			return;
		}
		if(!this.ruleFrom.email){
			Toast.fail("邮箱不能为空");
			return;
		}
		console.log(!this.ruleFrom.amount && this.ruleFrom.amount != 0)
		if(!this.ruleFrom.amount && this.ruleFrom.amount != 0){
			Toast.fail("发票金额不能为空");
			return;
		}
	    createOrder(this.ruleFrom).then(res => {
			if (res.success) {
				Toast.success("添加订单成功！");
				if(this.params.amount=='0'){
				var params = {
					amount: "0",
					result: 1,
					reason: "",
					orderId: res.result.id,
					memberCategory: 1
				};

				memberAudit(params)
						.then(res => {
							console.log(res)
							Toast.fail("会费已缴纳！");
							this.$router.push({ name: "PaymentList" });
						})
				}else{
					this.$router.push({ name: "PaymentList" });
				}
			} else {
				Toast.fail("创建订单失败！");
			}
		});
    },

	getMemberDues(){
		console.log(this.userInfo)
	  if(this.userInfo.memberCategory == 1 || this.userInfo.memberCategory == 4){
		getDuesList().then(res =>{
			if(res.success){
			this.memberDues = res.result;
			const dues = this.memberDues.filter(item => {
				return item.memberType === this.userInfo.memberType;
			});
			this.params.price = dues[0].amount;
			this.show = true;
			}
		});
	  }else if(this.userInfo.memberCategory == 2){
		 getGroupDues()
			.then(res =>{
				if(res.success){
					this.memberDues = res.result;
					const dues = this.memberDues.filter(item =>{
						return item.memberType === this.userInfo.memberType;
					})
					this.params.price = dues[0].amount;
					this.show = true;
				}
			})
	  }
    },
	headUpType() {
		if(this.ruleFrom.titleType == 1){
			this.ruleFrom.companyName = this.userInfo.name;
		}else {
			this.ruleFrom.companyName = ""
		}
    },
},
computed:{
  	orderId(){
  		return this.$route.query&&this.$route.query.orderId;
	},
	from(){
  		return this.$route.query&&this.$route.query.from;
	},
	...mapState(["userInfo"])
},
mounted() {
	this.ruleFrom.contact = this.userInfo.name;
	this.ruleFrom.mobile = this.userInfo.mobile;
	this.ruleFrom.email = this.userInfo.email;
	if(this.ruleFrom.titleType == 1){
		this.ruleFrom.companyName = this.userInfo.name;
	}else {
		this.ruleFrom.companyName = ""
	}
	if(this.userInfo.memberCategory == 2){
		this.ruleFrom.contact = "";
		this.ruleFrom.detailedAddress = this.userInfo.fullAddress;
	}
    setTimeout(this.getMemberDues,1000);
  }
};
</script>

<style type="text/css" lang="less" scoped>
/deep/.van-nav-bar .van-icon{
  color: #fff;
}
.content{ 
    padding:20px;
  p{ 
  	font-size: 14px; color: #000; margin:10px 0; margin-bottom: 20px;
   span{ color: #d64a4a; font-size: 12px; }
  }
}
/deep/.van-ellipsis{ display: inline-block; line-height: 50px;color: #dfdfdf;}
/deep/.van-nav-bar__text{color: #dfdfdf;}
/deep/.van-field__label{ width: 3rem;  color: #666; font-size:14px; }
/deep/.van-cell--required{padding-top:15px; padding-bottom: 15px;}
/deep/.van-cell{ border-bottom: #ededed solid 1px; }
/deep/.van-cell__title, .van-cell__value{
  margin-left: 15px;
}
.tishi{
	color: red;font-weight:700;margin-top:20px;margin-left:20px;line-height:20px;
	font-size: 15px;
}
</style>